import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email.trim()) return;

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('website_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setStatus('success');
      setEmail('');
      return;
    }

    setStatus('success');
    setEmail('');
  };

  return (
    <footer className="bg-secondary-900 text-foreground-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <h3 className="text-xl md:text-2xl font-heading font-bold mb-2">订阅更新提醒</h3>
            <p className="text-sm md:text-base text-foreground-300 mb-8 leading-relaxed">
              不想错过喜欢的韩漫更新？留下邮箱，第一时间获取最新章节通知。
            </p>
            <form onSubmit={handleSubmit}>
              <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="form-website-alt" />
              <label className="block text-xs text-foreground-400 mb-2">邮箱地址</label>
              <div className="flex flex-col sm:flex-row gap-3">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="hello@jiukuguoji.com"
                  required
                  className="flex-1 bg-transparent border-b border-foreground-500 px-2 py-2.5 text-sm text-white placeholder:text-foreground-500 focus:outline-none focus:border-primary-400 transition-colors"
                />
                <button
                  type="submit"
                  className="px-6 py-2.5 text-sm font-medium border border-foreground-500 rounded-lg text-foreground-200 hover:bg-foreground-500/20 hover:border-foreground-300 transition-all whitespace-nowrap cursor-pointer"
                >
                  订阅
                </button>
              </div>
              {status === 'success' && (
                <p className="text-xs text-green-400 mt-2">订阅成功！我们会第一时间通知您。</p>
              )}
            </form>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-3 gap-6 md:gap-10">
              <div>
                <h4 className="text-sm font-medium text-foreground-200 mb-4">
                  <Link to="/category/romance" className="hover:text-primary-400 transition-colors cursor-pointer">漫画分类</Link>
                </h4>
                <ul className="space-y-2.5">
                  <li><Link to="/category/romance" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer">浪漫爱情</Link></li>
                  <li><Link to="/category/fantasy" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer">奇幻冒险</Link></li>
                  <li><Link to="/category/thriller" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer">悬疑惊悚</Link></li>
                  <li><Link to="/category/urban" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer">都市职场</Link></li>
                  <li><Link to="/category/cultivation" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer">仙侠修真</Link></li>
                </ul>
              </div>
              <div>
                <h4 className="text-sm font-medium text-foreground-200 mb-4">
                  <Link to="/about" className="hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link>
                </h4>
                <ul className="space-y-2.5">
                  <li><Link to="/about" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer">品牌介绍</Link></li>
                  <li><a href="#" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer">用户协议</a></li>
                  <li><a href="#" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer">隐私政策</a></li>
                  <li><a href="#" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer">版权声明</a></li>
                </ul>
              </div>
              <div>
                <h4 className="text-sm font-medium text-foreground-200 mb-4">联系我们</h4>
                <ul className="space-y-2.5">
                  <li className="text-sm text-foreground-400 flex items-center gap-2">
                    <span className="w-4 h-4 flex items-center justify-center"><i className="ri-mail-line text-xs"></i></span>
                    hello@jiukuguoji.com
                  </li>
                  <li className="text-sm text-foreground-400 flex items-center gap-2">
                    <span className="w-4 h-4 flex items-center justify-center"><i className="ri-phone-line text-xs"></i></span>
                    021-5888-6666
                  </li>
                  <li className="text-sm text-foreground-400 flex items-center gap-2">
                    <span className="w-4 h-4 flex items-center justify-center"><i className="ri-map-pin-line text-xs"></i></span>
                    上海市浦东新区
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2022-2026 虚空韩漫网 jiukuguoji.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <Link to="/" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-foreground-200 transition-colors cursor-pointer" aria-label="首页">
              <i className="ri-home-4-line"></i>
            </Link>
            <Link to="/category/romance" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-foreground-200 transition-colors cursor-pointer" aria-label="分类">
              <i className="ri-stack-line"></i>
            </Link>
            <Link to="/about" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-foreground-200 transition-colors cursor-pointer" aria-label="关于">
              <i className="ri-information-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
